import { render } from "./IncomeStatementReport.vue?vue&type=template&id=059b781e&scoped=true"
import script from "./IncomeStatementReport.vue?vue&type=script&lang=js"
export * from "./IncomeStatementReport.vue?vue&type=script&lang=js"

import "./IncomeStatementReport.vue?vue&type=style&index=0&id=059b781e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059b781e"]])

export default __exports__